import { CommonModule } from "@angular/common";
import { Component, Inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FeedItem, Header, TopMenu } from './header.type';
import { MatMenuModule } from "@angular/material/menu";
import { UserInfos } from "../shared/ui/username-icon/user-infos.type";
import { HeaderService } from "./header.service";
import { UserService } from "@teammood/shared/util/user";
import { LoggerService } from "@teammood/shared/util/logger";
import { WINDOW } from "@teammood/shared/util/core";
import { HeaderMenuComponent } from "./header-menu/header-menu.component";
import { MatButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatMenuModule,
        HeaderMenuComponent,
        MatButton,
        RouterLink
    ]
})
export class TmHeaderComponent {

    @Input() header: Header
    @Input() devMode: boolean

    topMenu: TopMenu;
    userInfos: UserInfos;
    feed: FeedItem[];

    constructor(
        @Inject(WINDOW) private window: Window,
        private headerService: HeaderService,
        private userService: UserService,
        private logger: LoggerService,
    ) { }

    ngOnChanges(){
        if(this.header){
            this.topMenu = {
                teamMoodAdminMenu: this.header.teamMoodAdminMenu?.items,
                personalSettingsMenu: this.headerService.formatPSM(this.header),
                unread_feed_items_count: this.header.unreadFeedItemsCount,
                helpMenu: this.headerService.getHelpMenu(),
                accountMenu: this.headerService.formatAccountMenu(this.header),
                callToActionMenu: this.header.callToActionMenu
            }
            this.userInfos = new UserInfos(this.header.firstname, this.header.lastname)
        }
    }

    getFeed() {
        this.userService.getFeed().then((feed: FeedItem[]) => {
            this.topMenu.unread_feed_items_count = 0;

            this.feed = feed.map((feed_item) => {
                const urlFragments = feed_item.link.split("#")
                feed_item.anchor = urlFragments.at(-1);
                
                feed_item.click = () => {
                    if (feed_item.link) {
                        this.window.location.href = feed_item.link;
                        this.window.location.reload();
                    }
                };
                return feed_item;
            });
        }).catch((error) => {
            this.logger.warn("UserService.get_notifications() error", error);
        });
    }
}